import { METHOD } from "@/lib/constants";

// Elegant 6-step methodology diagram (night theme)
export default function MethodDiagram({ dark = true }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-6 gap-px rounded-lg overflow-hidden border border-[#2E2C2A]" data-testid="method-diagram">
      {METHOD.steps.map((s, i) => (
        <div key={s.key} className="bg-[#1C1B1A] p-6 relative group hover:bg-[#211f1d] transition-colors">
          <div className="eyebrow text-[#738075] mb-3">Step {i + 1}</div>
          <div className="font-display text-xl text-[#F7F5F0] mb-2">{s.label}</div>
          <p className="text-sm text-[#A39E98] leading-relaxed">{s.desc}</p>
          <div className="absolute bottom-0 left-6 right-6 h-px bg-gradient-to-r from-[#C2836B]/40 to-transparent scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
        </div>
      ))}
    </div>
  );
}
